import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { mediaQueryDown } from '../../utils/mediaQuery'

/** With an action the message may wrap to two lines within this width (Figma toast/snackbar). */
export const NOTIFICATION_WITH_ACTION_MAX_WIDTH = 560
export const NOTIFICATION_MOBILE_BREAKPOINT = 599

interface INotificationContainerProps {
  /** Second look: dark green, wrapping message, an action and a close icon. */
  $withAction?: boolean
}

export const NotificationContainer = styled.div<INotificationContainerProps>(
  ({ $withAction }) => ({
    top: ClinTheme.space[10],
    right: '10px',
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    borderRadius: ClinTheme.radii[3],
    backgroundColor: ClinTheme.colors.greenValid,
    zIndex: ClinTheme.zIndices.modal,
    ...($withAction && {
      boxSizing: 'border-box',
      maxWidth: NOTIFICATION_WITH_ACTION_MAX_WIDTH,
      gap: ClinTheme.space[2],
      padding: `${ClinTheme.space[2]}px ${ClinTheme.space[3]}px`,
      backgroundColor: ClinTheme.colors.deepGreen,
      boxShadow: ClinTheme.shadows[2],
      [mediaQueryDown(NOTIFICATION_MOBILE_BREAKPOINT)]: {
        left: '10px',
        maxWidth: 'none'
      }
    })
  })
)

export const VerticalLine = styled.div<INotificationContainerProps>(
  ({ $withAction }) => ({
    width: '1px',
    height: ClinTheme.space[3],
    margin: ClinTheme.space[3],
    backgroundColor: ClinTheme.colors.black,
    ...($withAction && {
      flexShrink: 0,
      margin: `0 ${ClinTheme.space[1]}px`,
      backgroundColor: ClinTheme.colors.white,
      opacity: 0.6
    })
  })
)

export const DismissButton = styled.button({
  marginRight: ClinTheme.space[2],
  paddingLeft: ClinTheme.space[0],
  fontWeight: ClinTheme.fontWeights.medium,
  fontSize: ClinTheme.fontSizes[1],
  backgroundColor: ClinTheme.colors.greenValid,
  color: ClinTheme.colors.aquaGreen,
  fontFamily: ClinTheme.fonts.body,
  cursor: 'pointer',
  border: 'none'
})

export const MessageText = styled.div({
  flex: '1 1 0',
  minWidth: 0
})

export const ActionButton = styled.button({
  flexShrink: 0,
  padding: `${ClinTheme.space[1]}px ${ClinTheme.space[2]}px`,
  fontWeight: ClinTheme.fontWeights.bold,
  fontSize: ClinTheme.fontSizes[1],
  backgroundColor: 'transparent',
  color: ClinTheme.colors.white,
  fontFamily: ClinTheme.fonts.body,
  cursor: 'pointer',
  border: 'none',
  whiteSpace: 'nowrap'
})

export const CloseIconButton = styled.button({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: ClinTheme.space[1],
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer'
})
